const breakpoints = {
    small: 768,
    medium: 992,
    large: 1280,
    xlarge: 1440,
};

export const customMediaQueryUp = (minWidth: number) => `@media (min-width: ${minWidth}px)`;
export const customMediaQueryDown = (maxWidth: number) => `@media (max-width: ${maxWidth}px)`;

export const mediaUp = {
    small: customMediaQueryUp(breakpoints.small),
    medium: customMediaQueryUp(breakpoints.medium),
    large: customMediaQueryUp(breakpoints.large),
    xlarge: customMediaQueryUp(breakpoints.xlarge),
};

export const mediaDown = {
    small: customMediaQueryDown(breakpoints.small),
    medium: customMediaQueryDown(breakpoints.medium),
    large: customMediaQueryDown(breakpoints.large),
    xlarge: customMediaQueryDown(breakpoints.xlarge),
};
